// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../../public/SiteIcons/listSeaechIcon.svg");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TripsContainer-container-oJos5 {
  margin: 0px auto;
  padding-top: 30px;
  max-width: var(--max-content-width);
}

.TripsContainer-panelHeader-FmiWa {
  border-radius: 0;
  width: 100%;
  display: block;
  font-size: 16px;
  border-bottom: 1px solid var(--primary-border);
  background: var(--background-primary);
  padding-bottom: 0px;
  margin-bottom: 0px;
}

.TripsContainer-listFlex-gmAa0 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  margin: 30px 0;
}

.TripsContainer-formControlInput-cDrf3 {
  width: 382px;
  height: 45px;
  border: 1px solid var(--primary-border);
  border-radius: 23px;
}

.TripsContainer-guestReservationSearchInput-O1w7w {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: 15px 50%;
  padding-left: 35px;
  background-size: 15px;
}

.TripsContainer-noMargin-uHJpJ {
  margin: 0;
}

@media screen and (max-width: 768px) {
  .TripsContainer-smPadding-m11oQ {
    margin-top: 20px;
  }
}

@media screen and (max-width: 767px) {
  .TripsContainer-formControlInput-cDrf3 {
    width: 100%;
  }

  .TripsContainer-mobileWidth-EjW3d {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/trips/TripsContainer.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,eAAe;EACf,8CAA8C;EAC9C,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,mDAA+D;EAC/D,4BAA4B;EAC5B,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".container {\n  margin: 0px auto;\n  padding-top: 30px;\n  max-width: var(--max-content-width);\n}\n\n.panelHeader {\n  border-radius: 0;\n  width: 100%;\n  display: block;\n  font-size: 16px;\n  border-bottom: 1px solid var(--primary-border);\n  background: var(--background-primary);\n  padding-bottom: 0px;\n  margin-bottom: 0px;\n}\n\n.listFlex {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 30px 0;\n}\n\n.formControlInput {\n  width: 382px;\n  height: 45px;\n  border: 1px solid var(--primary-border);\n  border-radius: 23px;\n}\n\n.guestReservationSearchInput {\n  background: url('../../../public/SiteIcons/listSeaechIcon.svg');\n  background-repeat: no-repeat;\n  background-position: 15px 50%;\n  padding-left: 35px;\n  background-size: 15px;\n}\n\n.noMargin {\n  margin: 0;\n}\n\n@media screen and (max-width: 768px) {\n  .smPadding {\n    margin-top: 20px;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .formControlInput {\n    width: 100%;\n  }\n\n  .mobileWidth {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `TripsContainer-container-oJos5`,
	"panelHeader": `TripsContainer-panelHeader-FmiWa`,
	"listFlex": `TripsContainer-listFlex-gmAa0`,
	"formControlInput": `TripsContainer-formControlInput-cDrf3`,
	"guestReservationSearchInput": `TripsContainer-guestReservationSearchInput-O1w7w`,
	"noMargin": `TripsContainer-noMargin-uHJpJ`,
	"smPadding": `TripsContainer-smPadding-m11oQ`,
	"mobileWidth": `TripsContainer-mobileWidth-EjW3d`
};
module.exports = ___CSS_LOADER_EXPORT___;
